import { useInvalidateQueries } from '@/hooks/useInvalidateQueries'
import { QUERY_KEYS } from '@/lib/queryKeys'

export function useInvalidateCommentQueries() {
  const invalidateQueries = useInvalidateQueries()

  return async function () {
    return invalidateQueries([
      QUERY_KEYS.comments(),
      QUERY_KEYS.companyReferralFirms(),
    ])
  }
}
